
import { useNavigate } from 'react-router-dom';

export default function ForumCategories() {
  const navigate = useNavigate();
  
  const categories = [
    {
      slug: 'tournaments',
      icon: 'ri-trophy-line',
      name: 'Tournaments',
      description: 'Discuss upcoming events and results',
      topics: 2847,
      posts: 18392,
      color: 'teal'
    },
    {
      slug: 'game-strategy',
      icon: 'ri-gamepad-line',
      name: 'Game Strategy',
      description: 'Share tips, tricks, and tactics',
      topics: 5621,
      posts: 42156,
      color: 'orange'
    },
    {
      slug: 'team-recruitment',
      icon: 'ri-team-line',
      name: 'Team Recruitment',
      description: 'Find teammates and build squads',
      topics: 1893,
      posts: 9847,
      color: 'teal'
    },
    {
      slug: 'training-coaching',
      icon: 'ri-graduation-cap-line',
      name: 'Training & Coaching',
      description: 'Improve your skills and learn',
      topics: 3214,
      posts: 21567,
      color: 'orange'
    },
    {
      slug: 'clips-highlights',
      icon: 'ri-video-line',
      name: 'Clips & Highlights',
      description: 'Share your best moments',
      topics: 4782,
      posts: 15234,
      color: 'teal'
    },
    {
      slug: 'general-discussion',
      icon: 'ri-chat-4-line',
      name: 'General Discussion',
      description: 'Talk about anything gaming',
      topics: 8956,
      posts: 67891,
      color: 'orange'
    }
  ];

  const handleCategoryClick = (slug: string) => {
    navigate(`/forums/category/${slug}`);
  };

  return (
    <section className="py-20 bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">Forum Categories</h2>
          <p className="text-gray-400 text-lg">Explore different topics and join the discussion</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((category, index) => (
            <div
              key={index}
              onClick={() => handleCategoryClick(category.slug)}
              className="bg-gray-900 border border-gray-800 rounded-xl p-6 hover:border-teal-500/50 transition-all cursor-pointer group"
            >
              <div className={`w-14 h-14 flex items-center justify-center bg-${category.color}-500/10 rounded-lg mb-4 group-hover:bg-${category.color}-500/20 transition-colors`}>
                <i className={`${category.icon} text-${category.color}-400 text-2xl`}></i>
              </div>

              <h3 className="text-xl font-bold text-white mb-2 group-hover:text-teal-400 transition-colors">
                {category.name}
              </h3>
              <p className="text-gray-400 text-sm mb-4">{category.description}</p>

              <div className="flex items-center gap-4 text-sm">
                <div className="flex items-center gap-1.5 text-gray-500">
                  <i className="ri-file-list-3-line"></i>
                  <span>{category.topics.toLocaleString()} topics</span>
                </div>
                <div className="flex items-center gap-1.5 text-gray-500">
                  <i className="ri-chat-3-line"></i>
                  <span>{category.posts.toLocaleString()} posts</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
